import {Injectable} from '@angular/core';
import {SettingsService} from 'app/original-services/settings.service';
import {StorageService} from 'app/original-services/storage.service';

export enum Level {
    OFF = 0,
    ERROR = 1,
    WARN = 2,
    INFO = 3,
    DEBUG = 4,
    LOG = 5
}

/**
 Use following commands in console:
 logger.level = x;
 logger.store() - save loglevel in browser localStore
 logger.unstore() - unsave loglevel in browser localStore
 **/
@Injectable({ providedIn: 'root' })
export class LoggerService {
    readonly storeAsKey: 'logger.level';
    private _level: Level;

    constructor(private storage: StorageService,
                private settings: SettingsService) {
        let storageLevel = this.getStorageLevel();
        if (!storageLevel) {
            this._level = settings.logLevel;
        }
        else {
            this.level = storageLevel;
        }

        (<any>window).logger = this;
    }

    get level(): Level {
        return this._level;
    }

    set level(value: Level) {
        this._level = value;
        if (this.getStorageLevel()) {
            this.store();
        }
    }

    getStorageLevel(): Level {
        return Number(this.storage.getStorageItem(this.storeAsKey));
    }

    store(): void {
        this.storage.setStorageItem(this.storeAsKey, (<number>this.level).toString());
    }

    unstore(): void {
        this.storage.removeStorageItem(this.storeAsKey);
    }

    error(message?: any, ...optionalParams: any[]) {
        this.level >= Level.ERROR && console.error.apply(message, arguments);
    }

    warning(message?: any, ...optionalParams: any[]) {
        this.level >= Level.WARN && console.warn.apply(message, arguments);
    }

    log(message?: any, ...optionalParams: any[]) {
        this.level >= Level.LOG && console.log.apply(message, arguments);
    }

    debug(message?: any, ...optionalParams: any[]) {
        this.level >= Level.DEBUG && console.debug.apply(message, arguments);
    }
}
